import { useEffect, useState } from 'react'
import { useCurrentUser } from 'context/useCurrentUser'
import { Navigate } from 'react-router-dom'
import { LoadingOverlay, Box } from '@mantine/core'

interface AdminProtectedWrapperProps {
  children: React.ReactNode
}

export const AdminProtectedWrapper = ({ children }: AdminProtectedWrapperProps) => {
  const { currentUser } = useCurrentUser()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (currentUser !== undefined) {
      setLoading(false)
    }
  }, [currentUser])

  if (loading) {
    return (
      <Box pos="relative" style={{ minHeight: '100vh' }}>
        <LoadingOverlay visible />
      </Box>
    )
  }

  if (!currentUser?.admin_account) {
    return <Navigate to="/error_permission" replace />
  }

  return <>{children}</>
}
